export default __webpack_public_path__ + "static/media/ExportIcon.02b34d7b.svg";